import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Main = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1 className="display-4 mb-5">TNM Service Status</h1>
        <Row>
          <Col>
            <Button
              variant="success"
              size="lg"
              href="https://stats.uptimerobot.com/gxzRZFARLZ"
              target="_blank"
              rel="noreferrer"
            >
              TNM Map Services Status
            </Button>{" "}
            <Button
              variant="success"
              size="lg"
              href="https://statuschecker.fgdc.gov/main-report/tnmser_111/agsmapserver"
              target="_blank"
              rel="noreferrer"
            >
              FGDC Service Checker Results
            </Button>
          </Col>
        </Row>
      </header>
    </div>
  );
};
export default Main;
